<section class="section-div">
  <div class="header-div">
    <h4>
      <ion-icon name="megaphone-outline"></ion-icon> Human Resources -
      {{ incubaterName }}
    </h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Availability of a dedicated full time Incubation Team
                    (Director, Chief Executive Officer and other Incubation
                    staff)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <!-- [ngClass]="{ 'success': getValue.privateInvChannelsStatus}" -->
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.availabilityIncTeamStatus)
                    "
                    [style.background]="
                      pickColor(getValue.availabilityIncTeamStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.availabilityIncTeamStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Availability of a dedicated full time Incubation Team
                    (Director, Chief Executive Officer and other Incubation
                    staff)
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.availabilityIncTeamIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.availabilityIncTeamIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.availabilityIncTeamUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.availabilityIncTeamUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.availabilityIncTeamdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.availabilityIncTeamStatus == 3 ||
                            getValue.availabilityIncTeamStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.availabilityIncTeamReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.availabilityIncTeamStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('availabilityIncTeamStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('availabilityIncTeamStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.availabilityIncTeamStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('availabilityIncTeamStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Overall experience of Incubation Staff in Startup Ecosystem
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.overallExperienceStatus)"
                    [style.background]="
                      pickColor(getValue.overallExperienceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.overallExperienceStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Overall experience of Incubation Staff in Startup Ecosystem
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.overallExperienceIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.overallExperienceIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Cumulative Work Experience :
                            <b>{{
                              getValue.overallExperienceTotalYearOfExperience
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.overallExperienceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.overallExperienceStatus == 3 ||
                            getValue.overallExperienceStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.overallExperienceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.overallExperienceStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('overallExperienceStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('overallExperienceStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.overallExperienceStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('overallExperienceStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex title_dco">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Capacity development program for Incubation staff. Number of
                    Training programs attended by the Management team members to
                    acquire management skills and best practices
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.capacityDevelopmentProgramStatus)
                    "
                    [style.background]="
                      pickColor(getValue.capacityDevelopmentProgramStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.capacityDevelopmentProgramStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Capacity development program for Incubation staff. Number of
                    Training programs attended by the Management team members to
                    acquire management skills and best practices
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.capacityDevelopmentProgramIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.capacityDevelopmentProgramIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs attended by the Incubation Staff :
                            <b>{{
                              getValue.capacityDevelopmentProgramNoOfTraining
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.capacityDevelopmentProgramDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.capacityDevelopmentProgramStatus == 3 ||
                            getValue.capacityDevelopmentProgramStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.capacityDevelopmentProgramReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.capacityDevelopmentProgramStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('capacityDevelopmentProgramStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('capacityDevelopmentProgramStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.capacityDevelopmentProgramStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('capacityDevelopmentProgramStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Human resources policy for Incubation Center staff
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.humanResourcesStatus)"
                    [style.background]="
                      pickColor(getValue.humanResourcesStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.humanResourcesStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Human resources policy for Incubation Center staff</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.humanResourcesIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.humanResourcesIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.humanResourcesDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.humanResourcesStatus == 3 ||
                            getValue.humanResourcesStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.humanResourcesReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.humanResourcesStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('humanResourcesStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('humanResourcesStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.humanResourcesStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('humanResourcesStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    SOP for Workspace / Labs / Infrastructure
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.workspaceLabsInfraStatus)"
                    [style.background]="
                      pickColor(getValue.workspaceLabsInfraStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.workspaceLabsInfraStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>SOP for Workspace / Labs / Infrastructure</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.workspaceLabsInfraIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.workspaceLabsInfraIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of SOPs for different operations :
                            <b>{{ getValue.workspaceLabsInfraNoOfSOP }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.workspaceLabsInfraDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.workspaceLabsInfraStatus == 3 ||
                            getValue.workspaceLabsInfraStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.workspaceLabsInfraReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.workspaceLabsInfraStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('workspaceLabsInfraStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('workspaceLabsInfraStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.workspaceLabsInfraStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('workspaceLabsInfraStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header>
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Trained or skilled manpower for the laboratory or to operate
                    machineries
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.trainedSkilledManpowerStatus)
                    "
                    [style.background]="
                      pickColor(getValue.trainedSkilledManpowerStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.trainedSkilledManpowerStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Trained or skilled manpower for the laboratory or to operate
                    machineries
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.trainedSkilledManpowerIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.trainedSkilledManpowerIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Skilled manpower :
                            <b>{{
                              getValue.trainedSkilledManpowerNoOfManpower
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.trainedSkilledManpowerDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.trainedSkilledManpowerStatus == 3 ||
                            getValue.trainedSkilledManpowerStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.trainedSkilledManpowerReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.trainedSkilledManpowerStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('trainedSkilledManpowerStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('trainedSkilledManpowerStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.trainedSkilledManpowerStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('trainedSkilledManpowerStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header>
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Consultants or Interns to offer support on specific domains
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.consultantsOrInternsStatus)
                    "
                    [style.background]="
                      pickColor(getValue.consultantsOrInternsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.consultantsOrInternsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Consultants or Interns to offer support on specific domains
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.consultantsOrInternsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.consultantsOrInternsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Interns / Consultants operating in the
                            Incubation Centre :
                            <b>{{
                              getValue.consultantsOrInternsNoOfConsultants
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.consultantsOrInternsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.consultantsOrInternsStatus == 3 ||
                            getValue.consultantsOrInternsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.consultantsOrInternsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.consultantsOrInternsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('consultantsOrInternsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('consultantsOrInternsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.consultantsOrInternsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('consultantsOrInternsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Grievences redressal mechanism
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.grievencesRedressalStatus)
                    "
                    [style.background]="
                      pickColor(getValue.grievencesRedressalStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.grievencesRedressalStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Grievences redressal mechanism</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.grievencesRedressalIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.grievencesRedressalIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.grievencesRedressalUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.grievencesRedressalUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.grievencesRedressalDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.grievencesRedressalStatus == 3 ||
                            getValue.grievencesRedressalStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.grievencesRedressalReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.grievencesRedressalStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('grievencesRedressalStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('grievencesRedressalStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.grievencesRedressalStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('grievencesRedressalStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Exit interview policy
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.exitInterviewPolicyStatus)
                    "
                    [style.background]="
                      pickColor(getValue.exitInterviewPolicyStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.exitInterviewPolicyStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Exit interview policy</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.exitInterviewPolicyIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.exitInterviewPolicyIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.exitInterviewPolicyDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.exitInterviewPolicyStatus == 3 ||
                            getValue.exitInterviewPolicyStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.exitInterviewPolicyReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.exitInterviewPolicyStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('exitInterviewPolicyStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('exitInterviewPolicyStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.exitInterviewPolicyStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('exitInterviewPolicyStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
